import { LubeServOnWheelsPreferredTime } from "enums/lubeserv-preferredtime";
import OilChangeType from "enums/oil-change-type";

export const lubeServOnWheelsBookingsFilterState = () => ({
  startDate: null,
  endDate: null,
  searchKey: "",
  type: [
    OilChangeType.dieselMonoGrade,
    OilChangeType.dieselMultiGrade,
    OilChangeType.dieselFullySynthetic,
    OilChangeType.dieselTerraSportFullySynthetic,
    OilChangeType.gasolineMonoGrade,
    OilChangeType.gasolineMultiGrade,
    OilChangeType.gasolineFullySynthetic5W40,
    OilChangeType.gasolineTerraSportFullySynthetic,
  ],
  selectedPreferredDate: null,
  selectedPreferredTime: [
    LubeServOnWheelsPreferredTime.nineAM,
    LubeServOnWheelsPreferredTime.twelvePM,
    LubeServOnWheelsPreferredTime.threePM,
  ],
  page: 1,
  perPage: 10,
});
